module.exports = __webpack_public_path__ + "static/media/jira.57f7cdc6.png";